function dataAtcLabelForForm(productForm) {
  if (!productForm || typeof productForm.getAttribute !== 'function') {
    return null;
  }
  const raw = productForm.getAttribute('data-atc-label');
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  return trimmed ? trimmed : null;
}

function inStockAddToBagText(productForm) {
  const custom = dataAtcLabelForForm(productForm);
  if (custom) return custom;
  return window.variantStrings.addTobag;
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      if (document.querySelectorAll('.template-product').length && !this.closest('#content_quickview')) {
        this.updateURL();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    const itemact = document.querySelectorAll('.proFeaturedImage .item');
    for (var i = 0; i < itemact.length; i++) {
      itemact[i].classList.remove('act')
    }
    newMedia.classList.add('act');
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPrice-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        const availabilityId = `ProductAvailability-${this.dataset.section}`;
        const availabilityDestination = document.getElementById(availabilityId);
        const availabilitySource = html.getElementById(availabilityId);
        if (availabilitySource && availabilityDestination) {
          availabilityDestination.innerHTML = availabilitySource.innerHTML;
        }
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
        const variant_id = document.getElementById("variant_id").getAttribute('value');
        const sku = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-sku');
        const variantSku = document.getElementById('variantSku');
        if (typeof variantSku !== 'undefined' && variantSku) {
          variantSku.innerHTML = sku;
        }
        syncProductPurchaseTotal(this.dataset.section);
        Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const variant_id = document.getElementById("variant_id").getAttribute('value');
      const qty_var = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-qty');
      if(qty_var < 1) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = inStockAddToBagText(productForm);
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantSelectsStick extends VariantSelects {
  constructor() {
    super();
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-sticky-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPriceStick-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-sticky-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = addButton && (addButton.querySelector('.js-sticky-atc-text') || addButton.querySelector('#AddToCartText'));
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text && addButtonText) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const stickyVariantInput = productForm.querySelector('#variant_id-stick');
      const stickyVariantId = stickyVariantInput ? stickyVariantInput.getAttribute('value') : null;
      const stickyProductSelect = productForm.querySelector('#productSelectStick');
      const stickyOption = stickyProductSelect && stickyVariantId ? stickyProductSelect.querySelector(`[value="${stickyVariantId}"]`) : null;
      const qtyVarRaw = stickyOption ? stickyOption.getAttribute('data-qty') : null;
      const qtyVar = qtyVarRaw !== null ? Number(qtyVarRaw) : null;

      if (qtyVar !== null && qtyVar < 1) {
        if (addButtonText) addButtonText.textContent = window.variantStrings.preorder;
      } else {
        if (addButtonText) addButtonText.textContent = inStockAddToBagText(productForm);
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-sticky-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonText = addButton && (addButton.querySelector('.js-sticky-atc-text') || addButton.querySelector('#AddToCartText'));
    if (!addButton || !addButtonText) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
}

customElements.define('variant-selects-stick', VariantSelectsStick);

function syncProductPurchaseTotal(sectionId) {
  if (!sectionId) return;
  const form = document.getElementById(`product-form-${sectionId}`);
  if (!form) return;
  const totalEl = document.getElementById(`ProductPurchaseTotal-${sectionId}`);
  if (!totalEl) return;
  const variantInput = form.querySelector('input[name="id"]');
  const productSelect = document.getElementById('productSelect');
  if (!variantInput || !productSelect) return;
  let opt = null;
  const vid = String(variantInput.value || '');
  for (let i = 0; i < productSelect.options.length; i++) {
    if (productSelect.options[i].value === vid) {
      opt = productSelect.options[i];
      break;
    }
  }
  if (!opt) return;
  const unit = parseInt(opt.getAttribute('data-unit-price-cents'), 10);
  if (Number.isNaN(unit)) return;
  const qtyInput =
    form.querySelector('input.quantity-selector[name="quantity"]') ||
    form.querySelector('input#Quantity[name="quantity"]') ||
    form.querySelector('input[name="quantity"]');
  let qty = 1;
  if (qtyInput && qtyInput.value !== '') {
    const n = parseInt(qtyInput.value, 10);
    if (!Number.isNaN(n) && n > 0) qty = n;
  }
  const totalCents = unit * qty;
  const format = typeof theme !== 'undefined' && theme.moneyFormat ? theme.moneyFormat : '${{amount}}';
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    totalEl.textContent = Shopify.formatMoney(totalCents, format);
  } else {
    totalEl.textContent = (totalCents / 100).toFixed(2);
  }
}

function runPurchaseTotalCurrencySync() {
  if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function' && typeof jQuery !== 'undefined') {
    Currency.convertAll(shopCurrency, jQuery('#currencies span.selected').attr('data-currency'));
  }
}

function initProductPurchaseTotalSync() {
  if (!document.querySelector('[id^="ProductPurchaseTotal-"]')) {
    return;
  }
  document.addEventListener('change', function (e) {
    const t = e.target;
    const form = t.closest && t.closest('form[id^="product-form-"]');
    if (!form) return;
    const sid = form.getAttribute('data-section');
    if (!sid) return;
    if (
      t.matches &&
      (t.matches('input[name="id"]') || t.matches('input[name="quantity"]') || t.matches('input.quantity-selector'))
    ) {
      syncProductPurchaseTotal(sid);
      runPurchaseTotalCurrencySync();
    }
  });
  document.addEventListener('input', function (e) {
    const t = e.target;
    if (!t.matches || !t.matches('input[name="quantity"], input.quantity-selector')) return;
    const form = t.closest('form[id^="product-form-"]');
    if (!form) return;
    const sid = form.getAttribute('data-section');
    if (!sid) return;
    syncProductPurchaseTotal(sid);
    runPurchaseTotalCurrencySync();
  });
  document.body.addEventListener('click', function (e) {
    const btn = e.target.closest && e.target.closest('.quick_view-qty');
    if (!btn) return;
    const form = btn.closest('form[id^="product-form-"]');
    if (!form) return;
    const sid = form.getAttribute('data-section');
    if (!sid) return;
    window.requestAnimationFrame(function () {
      syncProductPurchaseTotal(sid);
      runPurchaseTotalCurrencySync();
    });
  });
  document.querySelectorAll('[id^="ProductPurchaseTotal-"]').forEach(function (el) {
    const m = el.id.match(/^ProductPurchaseTotal-(.+)$/);
    if (m) syncProductPurchaseTotal(m[1]);
  });
  runPurchaseTotalCurrencySync();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductPurchaseTotalSync);
} else {
  initProductPurchaseTotalSync();
}
